var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper mt-3"},[(_vm.userType === 'adviser')?[(_vm.hasValidAccount)?_c('adviser-settings'):_c('f-alert',{staticClass:"my-5",attrs:{"visible":"","theme":"inactive"}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('settlements.sectionAvailableForActiveUsers'))+" ")])])]:(_vm.userType === 'customer')?[_c('customer-settings')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }